module.exports = __webpack_public_path__ + "img/navigationOpen.cf23509e.png";